export enum UserType {
	None = 0,
	ProjectOwner = 1,
	LineManager = 2,
	SuperUser = 3,
	Administrator = 4,
	Resource = 5
}